export const downloadObject = ({
  url,
  targetBlank = false,
}: {
  url: string
  targetBlank?: boolean
}) => {
  const a = document.createElement('a')
  a.href = url
  a.setAttribute('download', '')
  if (targetBlank) {
    a.setAttribute('target', '_blank')
    a.setAttribute('rel', 'noreferrer')
  }
  a.click()
  a.remove()
}
